import s from "./Footer.module.scss";


const Footer = () => {

    return (
        <footer>
                <img src="/assets/logoDEC.svg" alt="Don en Confiance. Votre don, notre engagement" />
                <nav>
                    <ul>
                        <li>5 rue Duroc, 75007 Paris</li>
                        <li>01 44 49 27 27</li>
                        <li><a href="https://www.avh.asso.fr" target="_blank">www.avh.asso.fr</a></li>
                    </ul>
                </nav>
                <nav className={s.social}>
                    <p>Suivez-nous :</p>
                    <ul >
                        <li><a href="https://www.facebook.com/AssociationValentinHauy/" target="_blank"><img src="/assets/socials/logoFb.png" alt="Lien vers le compte Facebook de l'association" /></a></li>
                        <li><a href="https://x.com/ValentinHauy" target="_blank"><img src="/assets/socials/logoX.png" alt="Lien vers le compte X, anciennement Twitter, de l'association" /></a></li>
                        <li><a href="https://www.instagram.com/associationvalentinhauy/" target="_blank"><img src="/assets/socials/logoInsta.png" alt="Lien vers le compte Instagram de l'association" /></a></li>
                        <li><a href="https://www.youtube.com/user/AssoValentinHauy" target="_blank"><img src="/assets/socials/logoYtb.png" alt="Lien vers la chaine Youtube de l'association" /></a></li>
                        <li><a href="https://www.linkedin.com/company/association-valentin-hauy/" target="_blank"><img src="/assets/socials/logoLkd.png" alt="Lien vers le compte LinkedIn de l'association" /></a></li>
                    </ul>
                </nav>
                <nav>
                    <ul>
                        <li><a href="https://www.avh.asso.fr/mentions-legales" target="_blank">Mentions légales</a></li>
                        <li><a href="https://www.avh.asso.fr/politique-des-cookies" target="_blank">Politique des cookies</a></li>
                        <li><a href="https://www.avh.asso.fr/charte-de-protection-des-donnees-personnelles" target="_blank">Charte de données personnelles</a></li>
                    </ul>
                </nav>
        </footer>
    )
}

export default Footer;